class CartUpgradeManager {
	constructor() {
		this.bindEvents()
	}

	upgradeItem(lineItemKey, productBVariantId, productBSellingPlanId, originalProductId, originalQuantity, postUpgradeText) {
		this._removeItem(lineItemKey)
			.then(() => this._addItem(productBVariantId, productBSellingPlanId, 1, { _original_product_id: originalProductId, _original_quantity: originalQuantity, _post_upgrade_text: postUpgradeText }))
	}

	undoUpgrade(lineItemKey, originalProductId, originalQuantity) {
		this._removeItem(lineItemKey)
			.then(() => this._addItem(originalProductId, '', originalQuantity))
	}

	_removeItem(lineItemKey) {
		return fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ id: lineItemKey, quantity: 0 })
		})
	}

	_addItem(variantId, sellingPlanId = '', quantity = 1, properties = {}) {
		return window.FctApp.cart.addToCart([{
			id: variantId,
			selling_plan: sellingPlanId,
			qty: quantity,
			properties
		}])
	}

	bindEvents() {
		document.addEventListener('click', (e) => {
			const upgradeBtn = e.target.closest('.upgrade-btn')

			if (upgradeBtn && upgradeBtn.matches('button')) {
				const key = upgradeBtn.dataset.lineItemKey
				const newId = upgradeBtn.dataset.upgradeVariantId
				const newSellingPlanId = upgradeBtn.dataset.upgradeSellingPlanId
				const originalId = upgradeBtn.dataset.originalId
				const originalQuantity = upgradeBtn.dataset.originalQuantity
				const postUpgradeText = upgradeBtn.dataset.postUpgradeText

				upgradeBtn.classList.add('loading-mode')

				this.upgradeItem(key, newId, newSellingPlanId, originalId, originalQuantity, postUpgradeText)
			}

			if (e.target.matches('.undo-btn')) {
				const key = e.target.dataset.lineItemKey
				const originalId = e.target.dataset.originalId
				const originalQuantity = Number(e.target.dataset.originalQuantity) || 1

				this.undoUpgrade(key, originalId, originalQuantity)
			}
		})
	}
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
	new CartUpgradeManager()
})
